import { createContext } from 'react'

import { ContextType } from 'ansok/types'

const Context = createContext<ContextType>({})

export default Context
